import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { LogService } from './logs.service';
import { LogSource, LogType } from '../models/common';
import { TemplateService } from './template.service';

export interface TransactionLogModel {
  accountId?: string;
  externalId: string;
  transactionType: number;
  redemptionStatus?: number;
  statusMessage?: string;
  sourceBucket?: string;
  balanceDeduction?: number;
  rateFrom?: number;
  rateTo?: number;
  conversionAmountCompleted?: number;
  balanceDeductionCompleted?: number;
  conversionType?: string;
  conversionLabel?: string;
  conversionAmount?: number;
  transactionDateTime?: Date;
  firstName?: string;
  lastName?: string;
  kioskId?: string;
  kioskName?: string; // as per Yan mapped to authService.preparedKioskDeviceId (kioskDeviceId from CHS URL)
  voucherID?: string;
  webhookStatus?: number;
  bak1?: string;
  bak2?: string;
  bak3?: string;
}

@Injectable({
  providedIn: 'root',
})
export class TransactionLogService {

  constructor(
    private readonly http: HttpClient,
    private readonly logService: LogService,

    private readonly templateService: TemplateService
  
  ) {}

  public async postTransactionLog(model: TransactionLogModel): Promise<void> {
    try {
      await this.http
        .post(
        `${environment.apiCobraUrl}/api/TransactionLog`, 
        model,
        { params: { api_key: this.templateService.templateData.advancedSettings.oc2ApiKey } }
      ).toPromise();
    } catch (error) {
    //silently log, never block redemption flow
      this.logService.writeLog(
        `TransactionLog post failed: ${JSON.stringify(error)}`,
        LogType.ERROR,
        LogSource.REDEMPTION
      );
    }
  }
}